import React from "react";
import Sidebar from "../components/Sidebar";
import { useMobileStatus } from "../hooks/useMobileStatus";
import MobileHeader from "../components/MobileHeader";
import CardList from "../components/CardList";

const HomePage = () => {
  const isMobile = useMobileStatus();

  return (
    <>
      {!isMobile && <Sidebar />}
      <div className="container-main container-big">
        {isMobile && <MobileHeader />}
        {!isMobile && (
          <div className="container-logo">
            <a href="https://www.btb.gmbh/" target="_blank">
              <img src="../../LogoBTB.png" />
            </a>
          </div>
        )}
        <CardList />
      </div>
    </>
  );
};

export default HomePage;
